import FoodRepository from './models/repository';
import Product        from './models/product';

export default FoodRepository;
export { Product };
